import { render } from "./QBEGroup.vue?vue&type=template&id=09a15fae&scoped=true&ts=true"
import script from "./QBEGroup.vue?vue&type=script&lang=ts"
export * from "./QBEGroup.vue?vue&type=script&lang=ts"

import "./QBEGroup.vue?vue&type=style&index=0&id=09a15fae&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a15fae"]])

export default __exports__